module.exports = __webpack_public_path__ + "static/media/parking_spot.3f421220.svg";